module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/makeup@2x_64bdd9.jpg";